import busEvents from '@/helper/busEvents';

export const emitPlayCrashWinSound = () => {
  busEvents.emit('playCrashWinSound');
};
export const onPlayCrashWinSound = (callback: () => void) => {
  busEvents.on('playCrashWinSound', callback);
};

export const emitPlayCrashBetSound = () => {
  busEvents.emit('playCrashBetSound');
};
export const onPlayCrashBetSound = (callback: () => void) => {
  busEvents.on('playCrashBetSound', callback);
};

export const emitPlayCrashBgSound = () => {
  busEvents.emit('PlayCrashBgSound');
};
export const emitStopCrashBgSound = () => {
  busEvents.emit('StopCrashBgSound');
};
export const onStopCrashBgSound = (callback: () => void) => {
  busEvents.on('StopCrashBgSound', callback);
};
export const onPlayCrashBgSound = (callback: () => void) => {
  busEvents.on('PlayCrashBgSound', callback);
};
